

export let userProfile = [
  {
    key: "name", displayName: "Name", order: 1, type: "string",
    error: "", value: "", helperText: "", required: true,
  },
  {
    key: "email", displayName: "Email", order: 2, type: "string",
    error: "", value: "", helperText: "", required: true, disabled: true,
  },
  {
    key: "role", displayName: "Role", order: 3, type: "select", select: true,
    error: "", value: "", helperText: "", required: true,
    options: [{ key: "user", value: "user" }, { key: "manager", value: "manager" }]
  },
];



